// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MediaQuery from 'react-responsive';
import uuidv4 from 'uuid/v4';
import classNames from 'classnames/bind';

import Input from '../Input/Input';
import styles from './styles';

class SearchCharityInput extends Component {
  state = {
    openPopup: false,
    charity: '',
    charities: this.props.charities,
  };

  componentDidMount() {
    const search = document.getElementById('tosearchCharity');
    search.addEventListener('focusin', () => {
      this.setState({ openPopup: true });
    });
    search.addEventListener('focusout', () => {
      this.setState({ openPopup: false });
    });
  }

  searchCharity = (value) => {
    const { charities } = this.props;
    const filter = value.toUpperCase();
    const filteredCharities = charities.filter(
      el => el.CharityName.toUpperCase().indexOf(filter) >= 0
    );
    this.setState({ charities: filteredCharities });
  }

  onChangeSearchInput = (value) => {
    this.setState({ charity: value });
    if (value) {
      this.searchCharity(value);
    } else {
      this.setState({ charities: this.props.charities });
    }
  }

  selectCharity = (el) => {
    const { selectCharityId } = this.props;
    this.setState({ charity: el.CharityName, openPopup: false });
    selectCharityId(el.CharityID);
  }

  renderPopup = () => {
    const { classes } = this.props;
    const { charities } = this.state;

    return this.state.openPopup ? (
      <MediaQuery minWidth={550}>
        {matches => (
          <div className={classNames(
            classes.popup,
            matches ? classes.desktopPopup : classes.mobilePopup
          )}
          >
            {charities.map((el, i) => (
              <button
                key={uuidv4()}
                onMouseDown={() => this.selectCharity(el)}
                id={`search-result-${i}`}
                className={classes.searchResult}
              >
                <span className={classes.popupLabel}>{el.CharityName}</span>
              </button>
            ))}
          </div>
        )}
      </MediaQuery>
    ) : null;
  }

  render() {
    const { classes, style } = this.props;
    return (
      <div className={classNames(style, classes.mainContainer)}>
        <Input
          name={'searchCharity'}
          placeholder={'Start typing charity name'}
          value={this.state.charity}
          onChange={this.onChangeSearchInput}
          labelStyle={classes.labelStyle}
          inputType={'text'}
          autoComplete={'off'}
          onFocus={() => this.setState({ openPopup: true, charities: this.props.charities })}
        />
        {this.renderPopup()}
      </div>
    );
  }
}

SearchCharityInput.propTypes = {
  classes: PropTypes.object,
  charities: PropTypes.array,
  selectCharityId: PropTypes.func,
  style: PropTypes.string,
};

SearchCharityInput.defaultProps = {
  classes: {},
  charities: [],
  selectCharityId: () => { },
  style: '',
};

export default withStyles(styles)(SearchCharityInput);
